
import { useBreak } from "hooks/useBreak"
import { Label } from "./Overview.label"
import { _bootstrap } from "state/store.bootstrap"
import { getFocus, useAtom, useGet } from "state/jotai"
import { current_language, rotate_by_slider } from "state/store.global"
import { AnimatePresence } from "framer-motion"
import { motion } from 'framer-motion'
import { MobileLabel } from "./MobileOverview.label"
import { _project } from "state/store.projects"

export const Overview = ({ index, rmode, status, showLabel, setShowLabel }) => {

    const labelOptions    = getFocus(_bootstrap, 'projectnames')
    const currentLanguage = useAtom(current_language)[0];
    const isRotate_Done = useGet(rotate_by_slider)
    const isDesktop = useBreak('md_up')

    const L = [ // desktop labels position
    { L1:[1393, 260]},
    { L1:[1200, 250]},
    { L1:[550, 550]},
    { L1:[900, 325]},
    { L1:[1393, 260]},
    ];

    const circle = [        // desktop circle position
        { L1:[50, 300]},
        { L1:[40, 350]},
        { L1:[0, -250]},
        { L1:[0, -200]},
        { L1:[50, 300]},
    ]

    const mobileL = [   // circle position 
        { L1:[1380, 230],},
        { L1:[1200, 255]},
        { L1:[600, 500],},
        { L1:[950, 300]},
        { L1:[1380, 230],},
        ];

    const mobileLine = [    // how much line shoule be big from both axis
        { L1:[ 450, 0 ]},
        { L1:[ 400, 0 ]},
        { L1:[ 550, 0 ]},
        { L1:[ 500, 0 ]},
        { L1:[ 450, 0 ]},
        ];

    const mobileLineAngle = [       // labels line rotation from the pin point (circle)
        { L1: 215},
        { L1: 285},
        { L1: 85},
        { L1: -285},
        { L1: 215},
        ];

    const mobileLabelAxis = [       // labels position (i.e top & left)
        { L1:[ 350, 0 ] },
        { L1:[ 380, 0 ]},
        { L1:[ 80, 0 ] },
        { L1:[ 80, 0 ] },
        { L1:[ 350, 0 ] },
        ];

    const animation = {
        initial: { opacity:0 },
        animate: { opacity:1 },
        exit:    { opacity:0 },
        transition: { duration:0.1, ease:'linear' },
      }

    return (
        <AnimatePresence>
        {
            status === 'DONE' && isRotate_Done &&
            <>
            {
                isDesktop ? 
                labelOptions?.[currentLanguage].map((label, i) => {
                    if(i) { // labels will genrate according to different properties
                        return (
                                <motion.div {...animation} key={i}>
                                     <Label setShowLabel={setShowLabel}  c={L?.[index]?.[`L${i}`]} sc={1} d={40} l={0} r={circle?.[index]?.[`L${i}`]} {...{ rmode }} labelsInfo = {label} showLabel={showLabel} /> 
                                </motion.div>)
                    }
                })
                :
                labelOptions?.[currentLanguage].map((label, i) => {
                    if(i) { // labels will genrate according to different properties
                        return (
                                <motion.div {...animation} key={i}>
                                    <MobileLabel setShowLabel={setShowLabel} c={mobileL?.[index]?.[`L${i}`]} sc={1} d={40} l={0} r={circle?.[index]?.[`L${i}`]} {...{ rmode }} labelsInfo = {label} line={mobileLine?.[index]?.[`L${i}`]} angle={mobileLineAngle?.[index]?.[`L${i}`]} mobileLabelAxis={mobileLabelAxis?.[index]?.[`L${i}`]} showLabel={showLabel}/>
                                </motion.div>)
                    }
                })
            }
            </>  
        }
        </AnimatePresence>
    )
}